import { DONUT_CHART_MIN_VALUE } from 'consts/charts'

/* eslint-disable @typescript-eslint/no-explicit-any */
const formatDonutChartData = (data: any[]) => {
  const total = data.reduce((acc, item) => acc + item.value, 0)
  return [...data]
    .sort((a, b) => b.value - a.value)
    .map((item: any) => ({
      ...item,
      value: total === 0 ? DONUT_CHART_MIN_VALUE : item.value,
      color: total === 0 ? 'gray' : item.color,
    }))
}

export { formatDonutChartData }
